import {
  computed,
  Injectable,
  resource,
  ResourceRef,
  Signal,
} from '@angular/core';
import { ITariffServiceAreaWithCredentialType } from '@web/dtos';
import { IApiResponse } from '@web/shared-types';
import { firstValueFrom } from 'rxjs';
import { TariffAreaGateway } from './tariff-area.gateway';

@Injectable({
  providedIn: 'root',
})
export class TariffAreaStore {
  private readonly gateway: TariffAreaGateway = new TariffAreaGateway();

  #tariffAreaResource: ResourceRef<
    IApiResponse<ITariffServiceAreaWithCredentialType[]> | undefined
  > = resource({
    loader: () => {
      return firstValueFrom(this.gateway.list());
    },
  });

  public readonly isLoading: Signal<boolean> = computed((): boolean =>
    this.#tariffAreaResource.isLoading()
  );
  public readonly tariffAreas: Signal<ITariffServiceAreaWithCredentialType[]> =
    computed((): ITariffServiceAreaWithCredentialType[] =>
      this.#tariffAreaResource.hasValue()
        ? (this.#tariffAreaResource.value()?.data ?? [])
        : []
    );
  public reload(): void {
    this.#tariffAreaResource.reload();
  }
}
